<template>
  <el-dialog
    title="意见反馈"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    center
  >
    <el-form :model="feedbackForm" :rules="rules" ref="feedbackForm" label-width="80px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="feedbackForm.name" placeholder="请输入您的姓名" maxlength="20"></el-input>
      </el-form-item>
      
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="feedbackForm.phone" placeholder="请输入您的手机号" maxlength="11"></el-input>
      </el-form-item>
      
      <el-form-item label="意见内容" prop="content">
        <el-input
          type="textarea"
          :rows="4"
          v-model="feedbackForm.content"
          placeholder="请输入您的宝贵意见"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitFeedback" :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: "FeedbackDialog",
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号格式'));
      } else {
        callback();
      }
    };
    
    return {
      dialogVisible: false,
      loading: false,
      feedbackForm: {
        name: '',
        phone: '',
        content: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 20, message: '姓名长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入意见内容', trigger: 'blur' },
          { min: 1, max: 500, message: '意见内容长度在 1 到 500 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 打开弹窗
    openDialog() {
      this.dialogVisible = true;
      // 重置表单
      if (this.$refs.feedbackForm) {
        this.$refs.feedbackForm.resetFields();
      }
    },
    
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.loading = false;
    },
    
    // 提交反馈
    submitFeedback() {
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.submitToApi();
        } else {
          return false;
        }
      });
    },
    
    // 提交到API接口
    async submitToApi() {
      try {
        const response = await axios.post('https://meiti.reportauto.cn/api/userSuggestion', {
          name: this.feedbackForm.name,
          phone: this.feedbackForm.phone,
          content: this.feedbackForm.content
        });
        
        console.log('API响应状态码:', response.status);
        console.log('API响应数据:', response.data);
        
        // 简化处理逻辑：只要HTTP状态码是2xx就认为是成功
        if (response.status >= 200 && response.status < 300) {
          console.log('API调用成功，准备显示消息');
          
          // 先显示成功消息，再关闭弹窗
          this.$message({
            message: '提交成功！感谢您的反馈',
            type: 'success',
            duration: 5000, // 延长显示时间到5秒
            showClose: true, // 显示关闭按钮
            offset: 100, // 增加垂直偏移，避免被遮挡
            customClass: 'feedback-success-message' // 添加自定义类名
          });
          
          console.log('成功消息已触发');
          
          // 延迟关闭弹窗，确保消息有足够时间显示
          setTimeout(() => {
            console.log('准备关闭弹窗');
            this.handleClose();
          }, 500);
        } else {
          // 处理非2xx状态码
          this.$message({
            message: '提交失败，请稍后重试',
            type: 'error',
            duration: 3000, // 延长显示时间到3秒
            showClose: true // 显示关闭按钮
          });
        }
      } catch (error) {
        console.error('提交反馈失败:', error);
        if (error.response && error.response.status === 401) {
          this.$message.error('提交失败：认证错误，请检查接口权限');
        } else {
          this.$message.error('网络错误，请稍后重试');
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-textarea {
  resize: none;
}
</style>